export const SET_TRAINERS = "SET_TRAINERS";
export const SET_FILTER_OPTIONS = "SET_FILTER_OPTIONS";
export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_FRANCHISE_LIST = "SET_FRANCHISE_LIST";
export const SET_USER = " SET_USER";
export const SET_IS_LOGGED_IN = " SET_IS_LOGGED_IN";
export const SET_SERVICES = "SET_SERVICES";
export const SET_PACKAGES = "SET_PACKAGES";
export const SET_PACKAGE_CATEGORIED = "SET_PACKAGE_CATEGORIED";
export const SET_SELECTED_COUNTRY = "SET_SELECTED_COUNTRY";
export const SET_SELECTED_FRANCHISE = "SET_SELECTED_FRANCHISE";
export const SET_FULL_SCREEN_LOADER = "SET_FULL_SCREEN_LOADER";
export const SET_CATEGORIES_FILTERS = "SET_CATEGORIES_FILTERS";
export const SET_SPECIALITY_FILTERS = "SET_SPECIALITY_FILTERS";
export const SET_CERTIFICATE_FILTERS = "SET_CERTIFICATE_FILTERS";
export const SET_LANGUAGE_FILTERS = "SET_LANGUAGE_FILTERS";
export const RESET_FILTERS = "RESET_FILTERS";
export const TOGGLE_FRANCHISE_MODAL_STATE = "TOGGLE_FRANCHISE_MODAL_STATE";
export const TOGGLE_SIGN_IN_SIGN_UP_MODAL_STATE =
  "TOGGLE_SIGN_IN_SIGN_UP_MODAL_STATE";
export const SET_PACKAGE_FACTOR = "SET_PACKAGE_FACTOR";
export const SET_COUPON = "SET_COUPON";
export const SET_APP_SETTINGS = "SET_APP_SETTINGS";
export const SET_CHAT_LIST = "SET_CHAT_LIST";
export const SET_USER_PACKAGE = "SET_USER_PACKAGE";
export const SET_SESSIONS_LIST = "SET_SESSIONS_LIST";
export const UPDATE_SESSIONS_LIST = "UPDATE_SESSIONS_LIST";
export const UPDATE_SESSION_DATA_IN_STORE = "UPDATE_SESSION_DATA_IN_STORE";
export const UPDATE_TRAINERS_LIST = "UPDATE_TRAINERS_LIST";
export const SET_ALL_PACKAGES_STATS = "SET_ALL_PACKAGES_STATS";
export const SET_BROADCAST_REQUEST_MODAL_IS_VISIVLE =
  "SET_BROADCAST_REQUEST_MODAL_IS_VISIVLE";
export const SET_STATES = "SET_STATES";
export const SET_CITIES = "SET_CITIES";
export const SET_USER_PAYMENTS = "SET_USER_PAYMENTS";
export const SET_ACTIVE_TRAINERS_LIST = "SET_ACTIVE_TRAINERS_LIST";
export const SET_ARCHIVED_TRAINERS_LIST = "SET_ARCHIVED_TRAINERS_LIST";
export const SET_SPECIALITIES_IN_FILTER_OPTIONS =
  "SET_SPECIALITIES_IN_FILTER_OPTIONS";
export const SET_SPECIALITIES_FILTER_OPTIONS =
  "SET_SPECIALITIES_FILTER_OPTIONS";

export const SET_TRAINER_SPECIALITIES = "SET_TRAINER_SPECIALITY";
export const SET_TRAINER_CERTIFICATES = "SET_TRAINER_CERTIFICATES";
export const SET_TRAINER_LANGUAGES = "SET_TRAINER_LANGUAGES";
export const SET_TRAINER_CATEGORIES = "SET_TRAINER_CATEGORIES";
export const NEW_SPECIALITY = "NEW_SPECIALITY";
export const NEW_CERTIFICATE = "NEW_CERTIFICATE";
